import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页', icon: 'home'}
    }]
  }
]

export const asyncRouterMap = [
  {
    path: '/integration',
    component: Layout,
    redirect: '/integration/clients',
    name: 'integrationManagement',
    alwaysShow: true,
    meta: {title: '接入管理', icon: 'ums-resource'},
    children: [
      {
        path: 'clients',
        name: 'integrationClients',
        component: () => import('@/views/integration/clients/index'),
        meta: {title: '接入系统', icon: 'ums-resource'}
      },
      {
        path: 'outbox',
        name: 'integrationOutbox',
        component: () => import('@/views/integration/outbox/index'),
        meta: {title: '通知发送记录', icon: 'ums-resource'}
      },
      {
        path: 'reconciliation',
        name: 'integrationReconciliation',
        component: () => import('@/views/integration/reconciliation/index'),
        meta: {title: '发布通知维护', icon: 'ums-resource'}
      },
      { path: 'builds', name: 'integrationBuilds', component: () => import('@/views/integration/builds/index'), meta: { title: '算法包管理', icon: 'ums-resource' } }
    ]
  },
  {
    path: '/app',
    component: Layout,
    redirect: '/app/list',
    name: 'appManagement',
    alwaysShow: true,
    meta: {title: 'APP管理', icon: 'product-list'},
    children: [
      {
        path: 'list',
        name: 'appList',
        component: () => import('@/views/app/appList'),
        meta: {title: 'APP列表', icon: 'product-list'}
      },
      {
        path: 'detail/:id',
        name: 'appDetail',
        component: () => import('@/views/app/appDetail'),
        props: true,
        meta: {title: 'APP详情'},
        hidden: true
      },
      {
        path: 'algorithm',
        name: 'appAlgorithmConfig',
        component: () => import('@/views/app/appAlgorithmConfig'),
        meta: {title: 'APP算法配置', icon: 'order'}
      },
      {
        path: 'parameter',
        name: 'appParameterConfig',
        component: () => import('@/views/app/appParameterConfig'),
        meta: {title: 'APP参数配置', icon: 'database'}
      },
      {
        path: 'report',
        name: 'appReportConfig',
        component: () => import('@/views/app/appReportConfig'),
        meta: {title: 'APP报告配置', icon: 'form'}
      },
      {
        path: 'report-builder',
        name: 'appReportBuilder',
        component: () => import('@/views/report/reportTemplateBuilderV2'),
        props: route => ({
          appMode: true,
          appId: route.query.appId || '',
          templateId: route.query.templateId || ''
        }),
        meta: {title: 'APP报告模板编辑'},
        hidden: true
      },
      {
        path: 'report-preview',
        name: 'appReportPreview',
        component: () => import('@/views/app/appReportPreview'),
        meta: {title: 'APP报告预览', icon: 'view'}
      }
    ]
  },
  {
    path:'/algo',
    component: Layout,
    redirect: '/algo/algorithm',
    name: 'algo',
    meta: {title: '算法'},
    children: [
      {
        path: 'algorithm',
        name: 'algorithm',
        component: () => import('@/views/algo/algorithm'),
        meta: {title: '算法管理'}
      },
      {
        path: 'algorithmReview',
        name: 'algorithmReview',
        component: () => import('@/views/algo/algorithmReview'),
        meta: {title: '算法审核'}
      },
      {
        path: 'algorithmGroup',
        name: 'algorithmGroup',
        component: () => import('@/views/algo/algorithmGroup'),
        meta: {title: '算法组管理'},
      },
      {
        path: 'parameter',
        name: 'parameterDef',
        component: () => import('@/views/algo/parameter/index'),
        meta: {title: '参数管理'}
      },
      {
        path: 'parameterForm',
        name: 'parameterDefForm',
        component: () => import('@/views/algo/parameter/form'),
        meta: {title: '参数定义'},
        hidden: true
      }
    ]
  },
  {
    path:'/report',
    component: Layout,
    redirect: '/report/templateManageV2',
    name: 'report',
    meta: {title: '报告'},
    children: [
      {
        path: 'runtimePreviewV2',
        name: 'reportRuntimePreviewV2',
        component: () => import('@/views/report/reportRuntimePreviewV2'),
        meta: {title: 'V2运行预览'}
      },
      {
        path: 'styleTemplateManageV2',
        name: 'styleTemplateManageV2',
        component: () => import('@/views/report/styleTemplateManage'),
        meta: {title: 'V2样式模板'}
      },
      {
        path: 'templateBuilderV2',
        name: 'reportTemplateBuilderV2',
        component: () => import('@/views/report/reportTemplateBuilderV2'),
        meta: {title: 'V2模板Builder'}
      },
      {
        path: 'templateManageV2',
        name: 'reportTemplateManageV2',
        component: () => import('@/views/report/reportTemplateManageV2'),
        meta: {title: 'V2模板管理'}
      }
    ]
  },
  {
    path:'/document',
    component: Layout,
    redirect: '/document/apiDocument',
    name: 'document',
    meta: {title: '文档'},
    children: [
      {
        path: 'inputDocument',
        name: 'inputDocument',
        component: () => import('@/views/document/simpleAlgorithm'),
        meta: {title: '文档录入'}
      },
      {
        path: 'inputDocumentForm',
        name: 'inputDocumentForm',
        component: () => import('@/views/document/simpleAlgorithmForm'),
        meta: {title: '文档'},
        hidden: true
      },
    ]
  },
  {
    path: '/apiDocument',
    component: Layout,
    redirect: '/apiDocument/list',
    name: 'apiDocument',
    meta: {title: 'API文档管理', icon: 'ums'}, // 建议添加一个icon
    children: [
      {
        path: 'browser',
        name: 'documentBrowser',
        component: () => import('@/views/md/browser'),
        meta: {title: '文档浏览', icon: 'ums'}
      },
      {
        path: 'list',
        name: 'documentList',
        component: () => import('@/views/md/list'),
        meta: {title: '文档列表', icon: 'ums'}
      },
      {
        path: 'editor',
        name: 'documentEditor',
        component: () => import('@/views/md/editor'),
        meta: {title: '文档编辑'},
        hidden: true // 编辑页通常不在侧边栏显示，由列表页跳转
      }
    ]
  },
  {
    path:'/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '权限', icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js